import { AdPlacement } from "@/components/ads/AdPlacement";
import {
  SciBreadcrumb,
  SciExplainer,
  SciHeader,
  SciPage,
} from "@/lib/science/sci-ui";
import { m } from "@/paraglide/messages";
import { RulerCalc } from "../components/RulerCalc";

export function CalculatorPage() {
  return (
    <SciPage>
      <SciBreadcrumb
        homeLabel={m.sci_breadcrumb_home()}
        toolName={m.ruler_tool_name()}
        toolPath="/ruler"
      />
      <SciHeader title={m.ruler_h1()} intro={m.ruler_intro()} />

      <RulerCalc />

      <SciExplainer
        howToTitle={m.sci_howto_title()}
        howTo={m.ruler_howto()}
        examplesTitle={m.sci_examples_title()}
        examples={[m.ruler_ex1(), m.ruler_ex2(), m.ruler_ex3()]}
        faqTitle={m.sci_faq_title()}
        faqs={[
          { q: m.ruler_faq_q1(), a: m.ruler_faq_a1() },
          { q: m.ruler_faq_q2(), a: m.ruler_faq_a2() },
          { q: m.ruler_faq_q3(), a: m.ruler_faq_a3() },
          { q: m.ruler_faq_q4(), a: m.ruler_faq_a4() },
        ]}
      />

      <AdPlacement className="mt-10" />
    </SciPage>
  );
}
